module.exports = __webpack_public_path__ + "static/media/maraca_novo-img2.81bde1de.jpg";